export enum GroupIdentityType {
    SmtpAddress,
    ExternalDirectoryObjectId,
}